import { render } from "./ProductOptions.vue?vue&type=template&id=e22a80f4&scoped=true"
import script from "./ProductOptions.vue?vue&type=script&lang=js"
export * from "./ProductOptions.vue?vue&type=script&lang=js"

import "./ProductOptions.vue?vue&type=style&index=0&id=e22a80f4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e22a80f4"]])

export default __exports__